export const overlayContentClasses = {
  frame:
    'bg-surface-canvas dark:-outline-offset-1 dark:bg-surface-level-800 dark:outline-focus-inverse/10 dark:shadow-none outline-1 outline-focus-level-900/5 ring-0 shadow-lg',
  menu: 'rounded-md',
  panel: 'rounded-3xl'
}
